<template>
  <ColumnPriceDropDown v-bind="{...$props, ...$attrs, clickable: true}">
    <el-input-number
      v-model="price"
      size="mini"
      :precision="2"
      :step="1"
      :min="0"
      :controls="false"
      style="width: 75px"
    ></el-input-number>
    <el-popover  placement="bottom" width="190" trigger="manual" v-model="popAlertVisible">
        <p style="color:#E6A23C;font-size:12px;font-weight:bold"><i class="el-icon-warning" style="font-size:14px"> [NOTICE] </i> More Than<br>3 AUD Below PriceA / COD !</p>
        <div style="text-align: right; margin: 0">
        <el-button type="primary" size="mini" @click="popAlertVisible = false">Sure</el-button>
        </div>
        <div slot="reference" ></div>
    </el-popover>
  </ColumnPriceDropDown>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import ColumnPriceDropDown from './ColumnPriceDropDown'
export default {
  name: 'ColumnPriceDropDownWithInput',
  components: {
    ColumnPriceDropDown
  },
  props: {
    rowId: {
      type: [String, Number],
      required: true
    }
  },
  created () {
    this.tValue = this.linePrice(this.rowId)
    this.bus.$on(`line-price-selected-${this.rowId}`, val => {
      this.priceChange(val)
    })
  },
  beforeDestroy () {
    this.bus.$off(`line-price-selected-${this.rowId}`)
  },
  data () {
    return {
      // popShow: false,
      popAlertVisible: false,
      tValue: ''
    }
  },
  computed: {
    ...mapGetters({
      linePrice: 'edit/linePrice',
      lineProduct: 'edit/lineProduct',
      orderTypeName: 'edit/orderTypeName'
    }),
    price: {
      get () {
        // 因为没有双向绑定vuex，我把get函数改为了vuex里面的getters
        // return this.tValue || undefined
        return this.linePrice(this.rowId) || undefined
      },
      set (val) {
        this.priceChange(val)
      }
    }
  },
  methods: {
    ...mapMutations({
      setPrice: 'edit/setPrice'
    }),
    priceChange (val) {
      this.tValue = val
      this.setPrice({ id: this.rowId, price: val })
      this.bus.$emit(`line-price-changed-${this.rowId}`, val)
    }
  },
  watch: {
  // 开销售开单时，输入的数字小于该行货品的A价格3元，则弹popover
    tValue: function (newval, oldVal) {
      if (this.orderTypeName === 'Invoice') {
        if (this.lineProduct(this.rowId).prices.length !== 0) {
          var classA = this.lineProduct(this.rowId).prices[2]
          if (classA.price !== undefined && newval < classA.price - 3) {
            this.popAlertVisible = true
          }
        }
      }
    }
  },
  inject: ['bus']
}
</script>
